export default __webpack_public_path__ + "static/media/transmissionBlack.5ab65a55.svg";